<template>
  <div id="app">
    <v-app>
      <v-main>
        <v-container fluid>
          <v-card elevation="0">
            <v-card-title class="pb-0">
              <header-tab-admin/>
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <main-card-admin/>
            </v-card-text>
          </v-card>
          <errors-alert/>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import HeaderTabAdmin from "./Admin/Cards/CardAdminAchievement/HeaderTabAdmin";
import MainCardAdmin from "./Admin/Cards/CardAdminAchievement/MainCardAdmin";
import ErrorsAlert from "./Errors/ErrorsAlert.vue";
import {mapActions} from "vuex";
export default {
  name: "TuningModule",

  created() {
    this.getListAchievementType();
  },

  components: {HeaderTabAdmin, MainCardAdmin, ErrorsAlert},

  methods: {
    ...mapActions({
      getListAchievementType: 'achievement_type/getListAchievementType'
    }),
  },
}
</script>

<style scoped>

</style>